import React from 'react';
import {ShareForward} from '@styled-icons/remix-fill/ShareForward';
import {Facebook} from '@styled-icons/material/Facebook';
import {Line} from '@styled-icons/remix-fill/Line';
import {Twitter} from '@styled-icons/bootstrap/Twitter';
import * as Ant from 'antd';

export default function ShareSection(props) {
  const {url} = props;

  return (
    <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
      分享：
      <div
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(url);
            Ant.message.success(`已複製分享連結`);
          } catch (err) {
            console.log(err);
            Ant.message.warn(`無法複製連結`);
          }
        }}
        className="share-btn">
        <ShareForward size={24} />
      </div>
      {/* <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                target="_blank"
                className="share-btn">
                <Facebook size={24} />
              </a>
              <a
                href={`https://social-plugins.line.me/lineit/share?url=${shareUrl}&text=`}
                target="_blank"
                className="share-btn">
                <Line size={24} />
              </a>
              <a
                href={`https://twitter.com/share?text=&url=${shareUrl}`}
                className="share-btn"
                target="_blank">
                <Twitter size={20} />
              </a> */}
    </div>
  );
}
